import Servers from "../../server"
export default{
    state: {
        streets:[],
        zones:[],
        residents:[],
    },
    mutations: {},
    getters: {},
    actions: {
        async ZonesList(context){
        let response = await context.rootGetters.api.get(Servers.serverApi + "api/zones")
        return response;
        },
        async StreetList(context, zoneuuid){
            let response = await context.rootGetters.api.get(Servers.serverApi + "api/streets/zones/" + zoneuuid)
            return response;
        }

    }
}

